<template>
  <div class="settings-container">
    <div class="page-header"><h2><span class="breadcrumb-level">系统管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">系统配置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">系统设置</span></h2></div>
    <el-card shadow="hover" style="margin-bottom:20px">
      <div style="display:flex;align-items:center;padding:12px 0">
        <span style="font-weight:600;margin-right:16px;white-space:nowrap">暂停服务</span>
        <el-switch v-model="storeClosed" @change="saveStoreClosed" />
        <div class="form-tip" style="margin-left:12px">开启后，商城下单、活动报名、日托、酒店、乐园结算将均不可用</div>
      </div>
      <el-button v-if="storeClosed" type="text" size="small" style="margin-bottom:12px" @click="editStoreClosedReason">修改原因</el-button>
    </el-card>
    <el-card shadow="hover">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="基本设置" name="basic">
          <el-form
            :model="settingsForm"
            :rules="rules"
            ref="settingsFormRef"
            label-position="top"
            label-width="120px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="系统名称" prop="system_name">
                  <el-input v-model="settingsForm.system_name" placeholder="请输入系统名称" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="系统版本" prop="system_version">
                  <el-input v-model="settingsForm.system_version" placeholder="请输入系统版本" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="管理员邮箱" prop="admin_email">
                  <el-input v-model="settingsForm.admin_email" type="email" placeholder="请输入管理员邮箱" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="contact_phone">
                  <el-input v-model="settingsForm.contact_phone" placeholder="请输入联系电话" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="系统描述">
                  <el-input v-model="settingsForm.system_description" type="textarea" placeholder="请输入系统描述" rows="4" />
                </el-form-item>
              </el-col>
            </el-row>

            <div class="form-actions">
              <el-button @click="handleReset">重置</el-button>
              <el-button type="primary" @click="handleSubmit" :loading="basicSaving">保存设置</el-button>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="安全设置" name="security">
          <el-card shadow="hover" style="margin-bottom: 20px;">
            <template #header>
              <div class="card-header-title">
                <span>登录安全</span>
              </div>
            </template>
            <el-form
              :model="securityForm"
              label-position="top"
              label-width="160px"
              v-loading="securityLoading"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="登录失败次数限制">
                    <el-input-number
                      v-model="securityForm.login_failure_limit"
                      :min="0"
                      :max="20"
                      placeholder="0表示不限制"
                      style="width: 100%;"
                    />
                    <div class="form-tip">连续登录失败达到此次数后锁定账号，0 表示不限制</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="登录锁定时长(分钟)">
                    <el-input-number
                      v-model="securityForm.login_lock_duration"
                      :min="1"
                      :max="1440"
                      placeholder="请输入锁定时长"
                      style="width: 100%;"
                    />
                    <div class="form-tip">达到失败次数后锁定账号的时长</div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-card shadow="hover">
            <template #header>
              <div class="card-header-title">
                <span>密码安全</span>
              </div>
            </template>
            <el-form
              :model="securityForm"
              label-position="top"
              label-width="160px"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="密码最小长度">
                    <el-input-number
                      v-model="securityForm.password_min_length"
                      :min="6"
                      :max="32"
                      placeholder="请输入密码最小长度"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="密码过期天数">
                    <el-input-number
                      v-model="securityForm.password_expire_days"
                      :min="0"
                      :max="365"
                      placeholder="0表示永不过期"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="密码复杂度要求">
                    <el-checkbox-group v-model="securityForm.password_complexity">
                      <el-checkbox label="包含大小写字母">包含大小写字母</el-checkbox>
                      <el-checkbox label="包含数字">包含数字</el-checkbox>
                      <el-checkbox label="包含特殊字符">包含特殊字符</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-card shadow="hover" style="margin-top: 20px;">
            <template #header>
              <div class="card-header-title">
                <span>会话安全</span>
              </div>
            </template>
            <el-form
              :model="securityForm"
              label-position="top"
              label-width="160px"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="会话超时(分钟)">
                    <el-input-number
                      v-model="securityForm.session_timeout"
                      :min="30"
                      :max="1440"
                      placeholder="请输入超时时长"
                      style="width: 100%;"
                    />
                    <div class="form-tip">管理员无操作超过此时间自动退出登录</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="同账号最大同时登录数">
                    <el-input-number
                      v-model="securityForm.session_concurrent_limit"
                      :min="0"
                      :max="20"
                      placeholder="0表示不限制"
                      style="width: 100%;"
                    />
                    <div class="form-tip">同账号同时在线的最大设备数</div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <div class="form-actions" style="margin-top: 20px;">
            <el-button @click="fetchSecurity">刷新</el-button>
            <el-button type="primary" @click="handleSecuritySubmit" :loading="securitySaving">保存设置</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import * as api from '../../api/settings';

export default {
  name: 'Settings',
  setup() {
    const activeTab = ref('basic');
    const settingsFormRef = ref(null);

    // 店铺状态（存 settings 表）
    const storeClosed = ref(false);
    const storeClosedReason = ref('');
    const saveStoreClosed = (val) => {
      if (val) {
        // 开启：弹出框让管理员填写原因
        ElMessageBox.prompt('开启后，小程序端将无法进行下单和结算操作', '暂停服务', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '可选，填写后用户端将显示此原因',
          inputType: 'textarea',
          distinguishCancelAndClose: true
        }).then(({ value }) => {
          const reason = value || ''
          storeClosedReason.value = reason
          api.batchSetSettings({
            'store_closed': { value: '1', type: 'boolean', description: '闭店状态' },
            'store_closed_reason': { value: reason, type: 'string', description: '闭店原因' }
          })
            .then(() => ElMessage.success('已暂停服务'))
            .catch(e => { storeClosed.value = false; ElMessage.error('操作失败：' + (e.message || '未知错误')) })
        }).catch(() => {
          storeClosed.value = false
        })
      } else {
        // 关闭：简单确认
        ElMessageBox.confirm('确认恢复服务？', '恢复服务', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'info' })
          .then(() => {
            storeClosedReason.value = ''
            api.batchSetSettings({ 'store_closed': { value: '0', type: 'boolean', description: '闭店状态' } })
              .then(() => ElMessage.success('已恢复服务'))
              .catch(e => { storeClosed.value = true; ElMessage.error('操作失败：' + (e.message || '未知错误')) })
          })
          .catch(() => {
            storeClosed.value = true
          })
      }
    }
    const editStoreClosedReason = () => {
      ElMessageBox.prompt('修改关闭原因', '关闭原因', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputValue: storeClosedReason.value,
        inputType: 'textarea',
        distinguishCancelAndClose: true
      }).then(({ value }) => {
        const reason = value || ''
        storeClosedReason.value = reason
        api.batchSetSettings({ 'store_closed_reason': { value: reason, type: 'string', description: '闭店原因' } })
          .then(() => ElMessage.success('已保存'))
          .catch(e => ElMessage.error('保存失败：' + (e.message || '未知错误')))
      })
    }

    // 基本设置
    const basicSaving = ref(false);
    const settingsForm = reactive({
      system_name: '宠镜宠物乐园',
      system_version: '1.0.0',
      admin_email: 'admin@example.com',
      contact_phone: '13800138000',
      system_description: '现代化的宠镜宠物乐园',
    });

    // 安全设置
    const securityLoading = ref(false);
    const securitySaving = ref(false);
    const securityForm = reactive({
      login_failure_limit: 5,
      login_lock_duration: 15,
      password_min_length: 6,
      password_expire_days: 0,
      password_complexity: ['包含大小写字母', '包含数字'],
      session_timeout: 120,
      session_concurrent_limit: 0,
    });

    const rules = {
      system_name: [
        { required: true, message: '请输入系统名称', trigger: 'blur' }
      ],
      admin_email: [
        { required: true, message: '请输入管理员邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
      ]
    };

    // 基本设置：通过 API 保存
    const handleSubmit = async () => {
      if (!settingsFormRef.value) return;
      try {
        await settingsFormRef.value.validate();
      } catch {
        return false;
      }
      try {
        await api.batchSetSettings({
          'basic.system_name': { value: settingsForm.system_name, description: '系统名称' },
          'basic.system_version': { value: settingsForm.system_version, description: '系统版本' },
          'basic.admin_email': { value: settingsForm.admin_email, description: '管理员邮箱' },
          'basic.contact_phone': { value: settingsForm.contact_phone, description: '联系电话' },
          'basic.system_description': { value: settingsForm.system_description, description: '系统描述' },
        });
        ElMessage.success('基本设置已保存');
      } catch (e) {
        ElMessage.error('保存失败：' + (e.message || '未知错误'));
      }
    };

    // 从后端拉取基本设置
    const fetchBasicSettings = async () => {
      try {
        const res = await api.getAllSettings();
        if (res && res.data) {
          if (res.data['basic.system_name'] !== undefined) settingsForm.system_name = res.data['basic.system_name'];
          if (res.data['basic.system_version'] !== undefined) settingsForm.system_version = res.data['basic.system_version'];
          if (res.data['basic.admin_email'] !== undefined) settingsForm.admin_email = res.data['basic.admin_email'];
          if (res.data['basic.contact_phone'] !== undefined) settingsForm.contact_phone = res.data['basic.contact_phone'];
          if (res.data['basic.system_description'] !== undefined) settingsForm.system_description = res.data['basic.system_description'];
          // 店铺状态
          storeClosed.value = res.data['store_closed'] === true || res.data['store_closed'] === '1'
          storeClosedReason.value = res.data['store_closed_reason'] || ''
        }
      } catch {}
    };

    const handleReset = () => {
      fetchBasicSettings();
    };

    // 拉取安全设置
    const fetchSecurity = async () => {
      securityLoading.value = true;
      try {
        const data = await api.getSecuritySettings();
        if (data) {
          securityForm.login_failure_limit = data.login_failure_limit;
          securityForm.login_lock_duration = data.login_lock_duration;
          securityForm.password_min_length = data.password_min_length;
          securityForm.password_expire_days = data.password_expire_days;
          securityForm.password_complexity = data.password_complexity || [];
          securityForm.session_timeout = data.session_timeout;
          securityForm.session_concurrent_limit = data.session_concurrent_limit;
        }
      } catch (e) {
        ElMessage.error('获取安全设置失败：' + (e.message || '未知错误'));
      } finally {
        securityLoading.value = false;
      }
    };

    // 保存安全设置
    const handleSecuritySubmit = async () => {
      securitySaving.value = true;
      try {
        await api.saveSecuritySettings({ ...securityForm });
        ElMessage.success('安全设置保存成功');
      } catch (e) {
        ElMessage.error('保存失败：' + (e.message || '未知错误'));
      } finally {
        securitySaving.value = false;
      }
    };

    // 切到安全设置 tab 时拉数据
    const onTabChange = (name) => {
      if (name === 'security') fetchSecurity();
    };

    onMounted(() => {
      // 拉取基本设置（含店铺状态）
      fetchBasicSettings();
      // 默认预拉安全设置（避免切 tab 时还要等）
      fetchSecurity();
    });

    return {
      activeTab,
      settingsFormRef,
      settingsForm,
      rules,
      securityForm,
      securityLoading,
      securitySaving,
      storeClosed,
      storeClosedReason,
      fetchBasicSettings,
      saveStoreClosed,
      editStoreClosedReason,
      handleSubmit,
      handleReset,
      handleSecuritySubmit,
      fetchSecurity,
      onTabChange,
    };
  }
};
</script>

<style scoped>
.reason-list { display: flex; flex-direction: column; gap: 6px; }
.reason-item { display: flex; align-items: center; gap: 4px; }

.settings-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.form-actions .el-button {
  margin-left: 10px;
}

.card-header-title {
  font-weight: 600;
  color: #333;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
}
</style>
